import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { withStyles } from '@material-ui/core/styles'

import Snackbar from '@material-ui/core/Snackbar'
import IconButton from '@material-ui/core/IconButton'
import CloseIcon from '@material-ui/icons/Close'


const styleSheet = theme => ({
})

class Notification extends Component {

	constructor(props, context) {
    	super(props, context)
    	this.handleNotificationClose = this.handleNotificationClose.bind(this)
	}

	handleNotificationClose() {
		this.props.store.dispatch({
		  type: 'REMOVE_NOTIFICATION'
		})
		this.forceUpdate()
	}

	render() {
		return (
			<Snackbar
				anchorOrigin={{
				  vertical: 'bottom',
				  horizontal: 'center',
				}}
				open={(this.props.store.getState().notifications.current ? true: false)}
				autoHideDuration={3000}
				onClose={this.handleNotificationClose}
				message={<span id="message-id">{this.props.store.getState().notifications.current}</span>}
				action={[
				  <IconButton
					key="close"
					aria-label="Close"
					color="inherit"
					onClick={this.handleNotificationClose}
				  >
					<CloseIcon />
				  </IconButton>,
				]}
			  />
		)
	}
} 

Notification.propTypes = {
	classes: PropTypes.object.isRequired,
	notification: PropTypes.string,
	store: PropTypes.object.isRequired
}

export default withStyles(styleSheet)(Notification)


// WEBPACK FOOTER //
// ./src/components/Notification.js